import {
    S3Client,
    ListObjectsV2Command,
    ListObjectsV2CommandInput,
    _Object, CommonPrefix
} from "@aws-sdk/client-s3";
import { S3_BUCKET_REGION, S3_PDB_BUCKET_NAME, S3_EMDB_BUCKET_NAME } from "../../config";
import { getFilteredListOfObjects, getFilteredListOfDirectories, getRootDirectories, getPubDirectories } from "./utils";
import { S3_objects } from "../../interfaces/S3_objects";

const s3Client = new S3Client({
    region: S3_BUCKET_REGION,
    signer: { sign: async (req) => req }
});

/**
 * Return the list of objects located under the given path.
 * @param {string} path Top level path to the objects.
 */
const listObjectsInPath = async (path: string): Promise<S3_objects> => {
    // If it's the root directory, just return the `/pub` directory.
    if (path === "") {
        return <S3_objects>{
            prefix: path,
            directories: getRootDirectories()
        }
    }

    // If it's the `/pub` path, return the `emdb` or `pdb` directory
    if (path === "pub/") {
        return <S3_objects>{
            prefix: path,
            directories: getPubDirectories()
        }
    }

    /* Reference the correct bucket, based on the path. If the path starts with `/pub/emdb`, then use the S3 bucket
       containing the EMDB file tree. Otherwise, default to use the S3 bucket with the PDB file tree. */
    const s3_bucket = path.startsWith('pub/emdb/') ? S3_EMDB_BUCKET_NAME : S3_PDB_BUCKET_NAME;

    const input = <ListObjectsV2CommandInput>{
        Bucket: s3_bucket,
        Prefix: path,
        Delimiter: "/"
    };

    let objects: _Object[] = [];
    let directories: CommonPrefix[] = [];
    let truncated = true;

    while (truncated) {
        try {
            const command = new ListObjectsV2Command(input);
            const response = await s3Client.send(command);

            directories = directories.concat(getFilteredListOfDirectories(response.CommonPrefixes));
            objects = objects.concat(getFilteredListOfObjects(response.Contents));

            truncated = !!response.IsTruncated;
            if (truncated) {
                input.ContinuationToken = response.NextContinuationToken;
            }
        } catch (err) {
            console.error(err);
            break;
        }
    }

    return <S3_objects>{
        prefix: path,
        directories,
        objects
    };
};

export { listObjectsInPath };